import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { handleOnAccountCreateUpdate } from '../../commonHandlerFunction/Collections/OnAccountHandler';
import ConfirmationModal from '../../ConfirmationModal';


const OnAccountButtons = ({ formData, handleSubmit, setIsOverlayLoader, viewOnly, setFormData }) => {

    const navigate = useNavigate();
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    return (

        <div className="auditBtns">
            <Button
                type="button"
                className="cancelBtn"
                onClick={() => navigate("/collections/on-accounts")}
            >
                Back
            </Button>
            {
                !viewOnly && (
                    <>
                    <Button
                        type="button"
                        className="submitBtn"
                        onClick={() =>
                            handleOnAccountCreateUpdate(formData, handleSubmit, setIsOverlayLoader, navigate)
                        }
                    >
                        Save
                    </Button>
                    <Button
                        type="button"
                        className="submitBtn"
                        onClick={() =>
                            // handleOnAccountCreateUpdate(formData, handleSubmit, setIsOverlayLoader, navigate,"post")
                            setIsConfirmOpen(true)
                        }
                    >
                        Close
                    </Button>
                    </>
                )
            }
            <ConfirmationModal isOpen={isConfirmOpen} handleClose={() => setIsConfirmOpen(false)} handleConfirm={() => handleOnAccountCreateUpdate(formData, handleSubmit, setIsOverlayLoader, navigate,"post")} popupMessage={"The On-account entry will be closed, Please confirm"} popupHeading={"Confirmation"} popbuttons={{ no: "No", yes: "Yes" }} setPopupClose={setIsConfirmOpen} />
        </div>
    )
}

export default OnAccountButtons
